import React, { createContext, useMemo } from 'react';
// eslint-disable-next-line import/no-cycle
import TableHead from './components/head/TableHead';
// eslint-disable-next-line import/no-cycle
import TableBody from './components/body/TableBody';
// eslint-disable-next-line import/no-cycle
import TableFooter from './components/footer/TableFooter';
import classes from './CustomTable.module.scss';
import { generateGrid } from './helpers';
import EmbedCard from './components/embedded/EmbedCard/EmbedCard';

export const TableContext = createContext(null);

export default function CustomTable(props) {
  const {
    data,
    columns,
    withHeader = true,
    withFooter = false,
    withEmbedded = false,
    embedContent = '',
    withLines,
    footerMargin,
    bodyWithBorderRadius,
    rowClickHandler = null,
    wrapperStyles = { backgroundColor: '#FFFFFF', boxShadow: '0 0 30px rgba(61, 107, 149, 0.1)' },
    headerStyles = { borderRadius: '10px 10px 0 0' },
    bodyStyles = { padding: '20px 26px 0 26px' },
    footerStyles = {},
    lineStyles = {},
    isLoading = false,
    loadingComponent
  } = props;

  const gridStyles = generateGrid(props.columns);

  const contextValue = useMemo(
    () => ({
      data,
      columns,
      gridStyles,
      withLines,
      rowClickHandler,
      headerStyles,
      bodyStyles,
      footerStyles,
      lineStyles
    }),
    [data, columns, gridStyles, withLines, headerStyles, rowClickHandler, lineStyles, bodyStyles]
  );

  return (
    <TableContext.Provider value={contextValue}>
      <div className={classes.tableWrapper} style={wrapperStyles}>
        {withHeader && <TableHead />}
        {!isLoading ? <TableBody withBorderRadius={bodyWithBorderRadius} /> : loadingComponent}
        {withFooter && <TableFooter margin={footerMargin} />}
        {withEmbedded && <EmbedCard>{embedContent}</EmbedCard>}
      </div>
    </TableContext.Provider>
  );
}
